import { ChangeDetectionStrategy, Component, ElementRef, Input, ViewChild, inject } from '@angular/core';
import { App } from '@df/core/app';
import { UiComponent } from '@df/ui/ui.component';
import { PaypalPayInThreeService } from './paypal-pay-in-three.service';
export namespace NPaypalPayInThreeMessageComponent {
    export const ID = 'paypal-pay-in-three-message';
    export interface IData {
        componentsId: string;
    }
}

@Component({
    selector: 'paypal-pay-in-three-message',
    templateUrl: './paypal-pay-in-three-message.html',
    styleUrls: ['./paypal-pay-in-three-message.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaypalPayInThreeMessageComponent extends UiComponent {
    @Input({ required: true })
    amount!: number;

    @Input()
    mode?: 'default' | 'basket' = 'default';

    @ViewChild('paypalMessage', { static: true, read: ElementRef })
    paypalMessageElement?: ElementRef<HTMLElement>;

    private app = inject(App);
    private paypalPayInThreeService = inject(PaypalPayInThreeService);

    private lastElement?: HTMLElement;

    override ngOnInit(): void {
        super.ngOnInit();
        if (this.app.isPlatformBrowser) {
            this.paypalPayInThreeService.load();
        }
        this.detectChanges();
    }

    override detectChanges(): void {
        super.detectChanges();
        this.refreshPaypalMessage();
    }

    private canActivate(): boolean {
        return this.app.isPlatformBrowser && this.amount > 0;
    }

    private refreshPaypalMessage(): void {
        if (!this.initiated) {
            return;
        }
        const container = this.paypalMessageElement?.nativeElement;
        this.lastElement?.remove();
        this.lastElement = undefined;
        if (container) {
            container.innerHTML = '';

            if (this.canActivate()) {
                const element = document.createElement('div');
                element.setAttribute('data-pp-amount', this.amount.toFixed(2));
                // element.setAttribute('data-pp-contextualComponents', this.mode === 'basket' ? 'PAY_LATER_BUTTON' : '');
                // element.setAttribute('data-pp-currency', this.app.multisite.current.currency);
                element.setAttribute('data-pp-message', '');
                element.setAttribute('data-pp-style-layout', 'text');
                element.setAttribute('data-pp-style-logo-type', 'primary');
                element.setAttribute('data-pp-style-logo-position', 'left');
                element.setAttribute('data-pp-style-text-align', 'left');

                if (this.client.isS) {
                    element.setAttribute('data-pp-style-text-size', '10');
                }
                // element.setAttribute('data-pp-buyercountry', this.app.multisite.current.country);
                // Clear the element to force PayPal SDK to re-render
                container.appendChild(element);
                // PayPal SDK watches for attribute changes and will re-render automatically
                // The data-pp-amount attribute is already updated via the template binding
                this.lastElement = element;
            }
        }
    }
}
